import { DateTime } from "luxon";
import { MonthPlanSimpleDto } from "shared/api";

type MonthPlanSimplest = Pick<MonthPlanSimpleDto, "year" | "month" | "status">;

export const nextMonthPlanDate = (monthPlans?: Array<MonthPlanSimplest>) => {
  if (!monthPlans) return null;
  if (monthPlans.length === 0) return DateTime.now();
  if (monthPlans.find((it) => it.status !== "APPROVED_AND_HAS_FINANCIAL_PLAN")) return null;

  const lastPlan = monthPlans[0];
  return DateTime.local(lastPlan.year, lastPlan.month + 1);
};
